var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5594_7595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6436 1.3913H1.35669V0H14.6436V1.3913Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98963 4.70957H6.0105V3.31827H9.98963V4.70957Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30444 6.01038V2.02429H8.69575V6.01038H7.30444Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33919 8.03483H6.0105V6.64352H7.33919V8.03483Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98958 8.03483H8.66089V6.64352H9.98958V8.03483Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33919 10.6853H6.0105V9.29398H7.33919V10.6853Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98958 10.6853H8.66089V9.29398H9.98958V10.6853Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68172 8.03483H3.35303V6.64352H4.68172V8.03483Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68172 10.6853H3.35303V9.29398H4.68172V10.6853Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68172 13.3426H3.35303V11.9513H4.68172V13.3426Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6468 8.03483H11.3181V6.64352H12.6468V8.03483Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6468 10.6853H11.3181V9.29398H12.6468V10.6853Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6468 13.3426H11.3181V11.9513H12.6468V13.3426Z",
    fill: "#55489E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98957 0H14.0104V4.97067L16 6.29936V16H8.63304V13.3426H7.36696V16H0V6.29936L1.98957 4.97067V0ZM3.38087 1.3913V5.71455L1.3913 7.04325V14.6087H5.97565V11.9513H10.0243V14.6087H14.6087V7.04325L12.6191 5.71455V1.3913H3.38087Z",
    fill: "#55489E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5594_7595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformGrid);
export default __webpack_public_path__ + "static/media/platform-grid.9944bfa9.svg";
export { ForwardRef as ReactComponent };